import Vue from 'vue'
import { firebase } from '@/firebase.js'

import App from '@/App.vue'
import store from './store/index.js'
import router from '@/router.js'

import '@/registerServiceWorker.js'
import '@/plugins.js'
import '@/icons.js'
import '@/filters.js'
import '@/css/styles.css'

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
if (
  process.env.NODE_ENV === 'production' &&
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1'
) {
  Sentry.init({
    dsn: 'https://d724c0093c414650944e12ac289e84f2@sentry.io/1443732',
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ]
  })
}

//document.cookie = 'SameSite=None; Secure'

Vue.config.productionTip = false

// If user is logged in on another device and changes stores:
// update the local data, too
store.watch(
  () => store.getters['user/storeName'],
  (storeName) => {
    // don't dispatch if this is the first load, or if a manual switch is already in progress
    if (store.getters['storeModule/id'] && !store.state.config.loading) {
      //console.log('switchStores from main.js')
      store.dispatch('switchStores', storeName)
      router.currentRoute.name !== 'dashboard' &&
        router.replace({ name: 'dashboard' })
    }
  }
)

let app = ''
firebase.auth().onAuthStateChanged(async (user) => {
  if (user) {
    store.dispatch('config/setLoading', true)
    store.dispatch('config/setDataLoaded', false)

    let data = await store.dispatch('user/bindUser', { uid: user.uid })

    store.dispatch('user/login', {})
    // Initialize active role after user data is loaded
    store.dispatch('user/initializeActiveRole')
    localStorage.setItem('signedIn', 'true')

    try {
      await Promise.all([
        store.dispatch('storeModule/bindStore', { storeId: data.store }),
        store.dispatch('recipes/bindStore') // Add this line to bind recipes at the root level
      ]).catch((e) => console.log(e))
    } catch {
      throw new Error('error binding to firestore!')
    }

    if (
      window.location.hostname !== 'localhost' &&
      window.location.hostname !== '127.0.0.1' &&
      process.env.NODE_ENV === 'production'
    ) {
      Sentry.configureScope((scope) => {
        scope.setUser({ email: user.email })
      })
    }

    store.dispatch('config/setDataLoaded', true)
    store.dispatch('config/setLoading', false)
  } else if (app) {
    store.dispatch('config/setLoading', true)
    store.dispatch('config/setDataLoaded', false)
    store.dispatch('user/logout')
    store.dispatch('storeModule/unbindStore')
    store.dispatch('recipes/unbindStore') // Add this line to unbind recipes when logging out
    store.dispatch('user/unbindUser')
    localStorage.removeItem('signedIn')
    store.dispatch('config/setLoading', false)
  }

  if (!app) {
    // eslint-disable-next-line require-atomic-updates
    app = new Vue({
      store,
      router,
      render: (h) => h(App)
    }).$mount('#app')
  }
})
